import { c as n, j as e } from "../../utils-BdNIfrGQ.js";
import { D as x } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import { F as a } from "../../Flex-BA9xHq_p.js";
import { L as b } from "../../List-L_RxfO5h.js";
import "../../Grid-DJGISvmf.js";
import "react";
import { T as l } from "../../Text-BhLXzYEf.js";
import { c as h } from "../../index-Di82Y7n3.js";
import "../../theme/provider/ThemeProvider.mjs";
import "../../ScrollToGrid-DSDgndge.js";
import "../../NavLink-D9Qfouy1.js";
import "../../HamburgerMenu-DtU03V0t.js";
import "../avatar/Avatar.mjs";
import { u } from "../../ResponsiveProvider-BC7BKjLV.js";
import "../../Button-CzIiGCVn.js";
import "../../toast-DrFMmSLk.js";
import "react-dom";
import "../../Button.skeleton-D0Onk1OP.js";
const j = h(
  [
    "relative",
    "block",
    "size-4",
    "border-2",
    "rounded-full",
    "bg-white",
    "mt-[0.5lh]",
    "-translate-y-1/2",
    "border-primary",
    "before:border-primary",
    "after:border-primary",
    "shrink-0"
  ],
  {
    variants: {
      isFirst: {
        false: [
          "before:content-['']",
          "before:absolute",
          "before:border-l-2",
          "before:left-1/2",
          "before:-translate-x-1/2",
          "before:block",
          "before:h-[9999px]",
          "before:bottom-full"
        ]
      },
      isLast: {
        false: [
          "after:content-['']",
          "after:absolute",
          "after:border-l-2",
          "after:left-1/2",
          "after:-translate-x-1/2",
          "after:block",
          "after:h-[9999px]",
          "after:top-full"
        ]
      }
    }
  }
), g = ({
  isFirst: t,
  isLast: s
}) => /* @__PURE__ */ e.jsx(
  "span",
  {
    "data-testid": "timeline-item-indicator",
    className: n(j({ isFirst: t, isLast: s }))
  }
), B = ({ items: t, variant: s = "default" }) => {
  const { isMobile: i } = u(), f = n(
    "flex-col gap-y-2 md:gap-x-7",
    s === "default" && "md:flex-row"
  );
  return /* @__PURE__ */ e.jsx("ol", { children: t.map((r, o) => {
    const d = o === 0, c = o === t.length - 1;
    return /* @__PURE__ */ e.jsxs(
      "li",
      {
        className: `relative overflow-hidden py-4 flex ${i ? "flex-col" : "flex-row"}`,
        children: [
          /* @__PURE__ */ e.jsxs(a, { className: "flex items-start gap-x-5 md:gap-x-7", children: [
            /* @__PURE__ */ e.jsx(g, { isFirst: d, isLast: c }),
            /* @__PURE__ */ e.jsxs(a, { className: f, children: [
              r.dateTime ? /* @__PURE__ */ e.jsx(
                "time",
                {
                  className: "text-nowrap text-muted-foreground md:w-[90px] shrink-0",
                  dateTime: r.dateTime,
                  children: /* @__PURE__ */ e.jsx(l, { children: r.label })
                }
              ) : /* @__PURE__ */ e.jsx(x, { className: "text-nowrap text-muted-foreground md:w-[90px] shrink-0", children: /* @__PURE__ */ e.jsx(l, { children: r.label }) }),
              r.details.length === 1 ? /* @__PURE__ */ e.jsx(l, { children: r.details[0] }) : /* @__PURE__ */ e.jsx(b, { children: r.details.map((m, p) => /* @__PURE__ */ e.jsx("li", { children: m }, `${m}-${p}`)) })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(a, { className: i ? "ml-6 mt-4" : "flex-grow justify-end", children: r.buttons })
        ]
      },
      `${r.dateTime}-${o}`
    );
  }) });
};
export {
  B as Timeline,
  g as TimelineItemIndicator
};
